import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { DebouncedSearchFieldComponent } from 'src/app/shared/components/debounced-search-field/debounced-search-field.component';
import * as XLSX from 'xlsx';
import { Router } from '@angular/router';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';

@Component({
  selector: 'app-upload-work-item',
  templateUrl: './upload-work-item.component.html',
  styleUrls: ['./upload-work-item.component.css']
})
export class UploadWorkItemComponent implements OnInit {

  isOpenDoctypeModel: boolean = false;
  isOpenUploadTypeModel: boolean = false;

  docTypeList: { docTypeId: number, docTypeName: string, limit: number, is_supportingFile_mandatory: boolean }[] = [];

  selectedDocumentType: { docTypeId: number, docTypeName: string, limit: number, is_supportingFile_mandatory: boolean } = null;

  excelFileData: any;
  lstDocument = [];
  workItemFieldList = [];
  workItemFieldChildList = [];
  workItemFieldList_All = [];
  lineItemList = [];

  lstDisplayData = [];
  lstDisplayField = [];
  lstChildDisplayField = [];

  lstHistoryData = [];
  lstHistoryColumnToHide = [];
  lstHistoyLinkColumn = [];

  lstHistoyFileData = [];
  lstColumnFormat = [];

  browseMessage = "No file selected.";
  fileControlType = 'file';
  selectedExcelFile = this.browseMessage;
  fileTitle = "Choose file";

  invoiceFileType = "";
  supportingFileType = "";
  invoiceFileSize = "";
  supportingFileSize = "";

  selectedInvoiceFiles = this.browseMessage;
  selectedSupportingFiles = this.browseMessage;

  invoiceNumberDBColumnName = '';

  folderName = "";
  selectedTab = 0;
  isValidated: boolean = false;
  loginVendorDetail: any;

  @ViewChild('invFileUpload') fileInput: ElementRef;
  @ViewChild('invFileUpload1') fileInput1: ElementRef;
  @ViewChild('invFileUpload2') fileInput2: ElementRef;
  @ViewChild('HistoryPopup') modelTemplate: TemplateRef<any>;

  modalReference: any;

  //Added for bulk FileUpload 
  isLoadProgress: boolean = false;
  file: File;
  fileSize: any;
  fileSizeInWords: any;
  fileBase64FileString: any = '';
  fileName: any = "";
  filefolderName: any = "";
  //end

  constructor(private commonService: CommonService, private dataService: DataService,
    private dialog: MatDialog, private modalService: NgbModal, private httpClient: HttpClient, private router: Router, private encryptDecryptservice: EncryptDecryptService,private memorystore: MemoryStorageService) {
  }

  ngOnInit(): void {
    this.getDocumentTypes();
  }

  getDocumentTypes() {
    this.docTypeList = [];

    let params = new HttpParams();
    // // params = params.append("project_id", this.commonService.getUserInfoFromLocalStorage('projectId'));
    // params = params.append("project_id", this.memorystore.getItem('projectId'));
    // params = params.append("subgroup_id", this.commonService.selectedSubgroup);
    // params = params.append("role_id", this.commonService.selectedRole);
    params = params.append("project_id", this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('projectId')));
    params = params.append("subgroup_id", this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedSubgroup));
    // params = params.append("role_id",  this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedRole));
    this.dataService.getData('invoice/getdocumenttypes', params).subscribe((res) => {
      if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
        if (res != null && res.data != null) {
          for (var i = 0; i < res.data.length; i++) {
            this.docTypeList.push({
              docTypeId: res.data[i].DOCUMENT_TYPE_ID,
              docTypeName: res.data[i].DOCUMENT_TYPE_NAME,
              limit: res.data[i].EXCEL_UPLOAD_DATA_LIMIT,
              is_supportingFile_mandatory: res.data[i].IS_SUPPORTING_FILE_MANDATORY_VP,
            });
          }
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      }
    );
  }

  getFileHistory() {

    this.lstHistoryData = [];

    let params = new HttpParams();
    params = params.append("DocumentTypeID", this.selectedDocumentType.docTypeId);
    params = params.append("ModuleName", "PI");
    // params = params.append("UserId", this.commonService.getUserInfoFromLocalStorage('userId'));
    params = params.append("UserId", this.memorystore.getItem('userId'));
    this.dataService.getData("invoice/uploadhistory", params, this.dataService.apiURL_Core).subscribe(res => {
      if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
        if (res.success == true) {

          this.lstHistoryColumnToHide.push("DOCUMENT_TYPE_ID");

          this.lstHistoyLinkColumn.push("Total Records");
          this.lstHistoyLinkColumn.push("No Of Valid");
          this.lstHistoyLinkColumn.push("No Of Invalid");

          res.data.forEach(row => {
            this.lstHistoryData.push({
              "File_Id": row.FILE_ID,
              "Work Item Type": row.DocumentTypeName, "File Name": row.FileName, "Upload Date": this.commonService.formatDate(row.CreatedDate, this.commonService.DateFormat),
              "Uploaded By": row.CreatedBy, 'Status': row.Status == 'Upload' ? 'In Progress' : row.Status, "Total Records": row.TotalRecord, 'No Of Valid': row.NoOfValid,
              "No Of Invalid": row.NoOfInvalid, "No Of Duplicate": row.NoOfDuplicate, 'DOCUMENT_TYPE_ID': row.DOCUMENT_TYPE_ID
            });
          });

          this.lstColumnFormat = [];
          this.lstColumnFormat.push({ columnName: 'Work Item Type', alignment: 'left' });
          this.lstColumnFormat.push({ columnName: 'File Name', alignment: 'left' });
          this.lstColumnFormat.push({ columnName: 'Upload Date', alignment: 'left' });
          this.lstColumnFormat.push({ columnName: 'Uploaded By', alignment: 'left' });
          this.lstColumnFormat.push({ columnName: 'Status', alignment: 'left' });
          this.lstColumnFormat.push({ columnName: 'Total Records', alignment: 'center' });
          this.lstColumnFormat.push({ columnName: 'No Of Valid', alignment: 'center' });
          this.lstColumnFormat.push({ columnName: 'No Of Invalid', alignment: 'center' });
          this.lstColumnFormat.push({ columnName: 'No Of Duplicate', alignment: 'center' });

        }
        else {
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    }, error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    })

  }

  async onChangeDoctype(docType: any) {
    this.isOpenDoctypeModel = false;
    this.selectedDocumentType = docType;
    debugger;
    this.lstDisplayData = [];
    this.lstDisplayField = [];

    //this.lstUploadData = [];

    this.selectedExcelFile = this.browseMessage;
    this.selectedInvoiceFiles = this.browseMessage;
    this.selectedSupportingFiles = this.browseMessage;

    this.getWorkItemFields();
    debugger;
    this.getWorkItemAllFields();
    debugger;
    this.getFileHistory();
  }

  async getWorkItemFields() {

    this.workItemFieldList = [];

    let params = {
      project_id: this.commonService.selectedProject,
      document_type_id: this.selectedDocumentType.docTypeId,
    };

    await this.dataService.getDataPromise('dynamic_fields', params).then((res) => {
      if (res != null)
        this.workItemFieldList = res.data;
      // let field = this.workItemFieldList.find(x => x.parent_field_config_name == 'Vendor Name')
      // if (field != undefined)
      //   this.vendorNameDBColumnName = field.db_column_name

      let field = this.workItemFieldList.find(x => x.parent_field_config_name == 'Invoice Number')
      if (field != undefined)
        this.invoiceNumberDBColumnName = field.db_column_name

      this.workItemFieldList.forEach(async (field) => {
        if (field.actions != null) {
          field.actions = JSON.parse(field.actions);
        }
      });
      debugger;
      this.workItemFieldList_All = Object.assign(this.workItemFieldList_All, this.workItemFieldList);
      this.workItemFieldList = this.workItemFieldList.filter(f => f.is_coding_template_upload == 1);
      this.invoiceFileType = "PDF"
      this.supportingFileType = "PDF";

      this.invoiceFileSize = "10";
      this.supportingFileSize = "10";
      debugger;
    }, err => {
    });
  }

  async getWorkItemAllFields() {
    debugger;
    this.workItemFieldList = [];
    this.workItemFieldChildList = [];

    // let params = {
    //   project_id: this.commonService.selectedProject,
    //   document_type_id: this.selectedDocumentType.docTypeId,
    // };

    // this.dataService.getData('template_fields', params).subscribe((res) => {

    let request = {
      project_id: this.commonService.selectedProject,
      doctype_id: this.selectedDocumentType.docTypeId,
      // role_id: this.commonService.getUserInfoFromLocalStorage('roleId'),
      role_id: this.memorystore.getItem('roleId'),
      Language: 'en',
      // userid: this.commonService.getUserInfoFromLocalStorage('userId'),
      userid: this.memorystore.getItem('userId'),
      module_name: 'AP'
    };

    await this.dataService.postDataPromise("invoice/work-item-fields", request).then(res => {
      if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
        if (res != null)
          this.workItemFieldList = res.data.Table;
        debugger;
        debugger;
        if (res.data.Table2 != undefined) {
          if (res.data.Table2.length > 0) {
            this.workItemFieldChildList = res.data.Table2;
          }
        }
        debugger;
        let field = this.workItemFieldList.find(x => x.parent_field_config_name == 'Invoice Number')
        if (field != undefined)
          this.invoiceNumberDBColumnName = field.db_column_name

        this.workItemFieldList_All = Object.assign(this.workItemFieldList_All, this.workItemFieldList);

        this.workItemFieldList = this.workItemFieldList.filter(f => f.is_coding_template_upload == 1);

        if (this.workItemFieldChildList != null) {
          if (this.workItemFieldChildList.length > 0) {
            this.workItemFieldChildList = this.workItemFieldChildList.filter(f => f.is_coding_template_upload == 1);

            this.workItemFieldChildList.forEach(async field => {
              if (field.control_type == "DROPDOWN") {
                let dropdown_dependant_parameter = {};
                field.dropdown_dependant_parameter = dropdown_dependant_parameter;
                field.options = await this.commonService.getDropdownData(field.field_mapping_detail_id, 0, dropdown_dependant_parameter);
              }
            });
          }
        }
        this.invoiceFileType = "PDF"
        this.supportingFileType = "PDF";
        debugger;
        this.invoiceFileSize = "10";
        this.supportingFileSize = "10";

        this.invoiceFileType = this.workItemFieldList[0].allowed_file_type;
        this.supportingFileType = this.workItemFieldList[0].supporting_file_upload_type;

        this.invoiceFileSize = this.workItemFieldList[0].allowed_file_size;
        this.supportingFileSize = this.workItemFieldList[0].supporting_file_upload_size;
        debugger;
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    }, error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });
  }

  downloadExcelTemplate() {

    if (this.selectedDocumentType == null || this.selectedDocumentType == undefined) {
      this.commonService.showMessageBox("Please select a Work item type.", "Alert");
      return
    }
    let lstFile = [];
    let obj = {};
    let master_data = [];

    this.workItemFieldList.forEach(field => {
      if (field.control_type != "FILE") {
        obj[field.parent_field_config_name] = '';
      }
    });

    obj["Invoice File Name"] = "";

    if (this.selectedDocumentType.is_supportingFile_mandatory == true)
      obj["Supporting File Name"] = "";

    var master_data_length = 0;
    if (this.workItemFieldChildList != null) {
      this.workItemFieldChildList.forEach(field => {
        if (field.control_type == "DROPDOWN") {
          if (field.options.length > master_data_length) {
            master_data_length = field.options.length;
          }
        }
      });

      if (this.workItemFieldChildList != null) {
        this.workItemFieldChildList.forEach(field => {
          if (field.control_type != "FILE") {
            obj[field.parent_field_config_name] = '';
          }
        });
      }

      for (var i = 0; i < master_data_length; i++) {
        let obj1 = {};
        this.workItemFieldChildList.forEach(field => {
          if (field.control_type == "DROPDOWN") {
            if (field.options.length <= master_data_length && field.options.length >= i) {
              obj1[field.parent_field_config_name] = field.options.map((d) => d.name)[i];
            }
          }
        });

        master_data.push(obj1);
      }
    }

    lstFile.push(obj);

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(lstFile);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws_master: XLSX.WorkSheet = XLSX.utils.json_to_sheet(master_data);

    ws_master['!protect'] = { selectLockedCells: false, autoFilter: false, formatColumns: false };
    XLSX.utils.book_append_sheet(wb, ws, 'LoadDataSheet');
    XLSX.utils.book_append_sheet(wb, ws_master, 'MasterData');
    XLSX.writeFile(wb, this.selectedDocumentType.docTypeName + '_' + new Date().getTime() + '.xlsx');

  }

  onSelectExcelFile(file) {

    if (file.target.files[0].type.toLowerCase() != "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      this.commonService.showMessageBox("Please select excel data file.", "Alert");
      this.fileInput.nativeElement.value = '';
      return;
    }

    this.selectedExcelFile = file.target.files[0].name;

    let workBook = null;
    let jsonData = null;

    const reader = new FileReader();
    const excelfile = file.target.files[0];

    reader.onload = (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary' });

      const sheet = workBook.Sheets['LoadDataSheet'];

      if (sheet != undefined)
        this.excelFileData = XLSX.utils.sheet_to_json(sheet, { defval: "" });

      if (this.excelFileData == undefined || this.excelFileData.length == 0) {
        this.commonService.showMessageBox("No data found in file.", "Alert");
        this.fileInput.nativeElement.value = '';
        this.selectedExcelFile = this.browseMessage;
        return;
      }

      if (this.selectedDocumentType.limit > 0 && this.excelFileData.length > this.selectedDocumentType.limit) {
        this.commonService.showMessageBox("No of records in excel file is more then the configured limit.<BR>" + "The record limit is " + this.selectedDocumentType.limit + ".", "Alert");
        this.fileInput.nativeElement.value = '';
        this.selectedExcelFile = this.browseMessage;
        return;
      }

      let missingCol = "";
      let cols = Object.keys(this.excelFileData[0]);
      this.workItemFieldList.forEach(f => {
        if (cols.findIndex(a => a == f.parent_field_config_name) == -1) {
          missingCol = (missingCol == '') ? f.parent_field_config_name : missingCol + ', ' + f.parent_field_config_name;
        }
      });

      if (this.workItemFieldChildList != null) {
        if (this.workItemFieldChildList.length > 0) {
          this.workItemFieldChildList.forEach(f => {
            if (cols.findIndex(a => a == f.parent_field_config_name) == -1) {
              missingCol = (missingCol == '') ? f.parent_field_config_name : missingCol + ', ' + f.parent_field_config_name;
            }
          });
        }
      }

      if (!cols.includes("Invoice File Name")) {
        missingCol = (missingCol == '') ? "Invoice File Name" : missingCol + ', ' + "Invoice File Name";
      }
      if (this.selectedDocumentType.is_supportingFile_mandatory == true && !cols.includes("Supporting File Name")) {
        missingCol = (missingCol == '') ? "Supporting File Name" : missingCol + ', ' + "Supporting File Name";
      }

      if (missingCol != "") {
        this.commonService.showMessageBox("Below column(s) are missing in excel data file.<br>" + missingCol, "Alert");
        this.fileInput.nativeElement.value = '';
        this.selectedExcelFile = this.browseMessage;
        return;
      }

      //------------------------------------------------------------
      this.lstDisplayField = [];
      this.lstChildDisplayField = [];
      this.lstDisplayField.push({ fieldName: 'Sr No' })
      this.lstDisplayField.push({ fieldName: 'Invoice File' });

      if (this.selectedDocumentType.is_supportingFile_mandatory == true)
        this.lstDisplayField.push({ fieldName: 'Supporting File' });

      this.workItemFieldList.forEach(field => {
        if (field.is_grid_display_bulk_upload_vendor == 1) {
          this.lstDisplayField.push({ fieldName: field.parent_field_config_name });
        }
      });

      if (this.workItemFieldChildList != null) {
        this.workItemFieldChildList.forEach(field => {
          if (field.is_grid_display_bulk_upload == 1) {
            this.lstChildDisplayField.push({ fieldName: field.parent_field_config_name });
          }
        });
        this.lstDisplayField.push({ lstchild: this.lstChildDisplayField });
      }

      this.lstDisplayField.push({ fieldName: 'Message' });
      this.lstChildDisplayField.push({ fieldName: 'Message' });

      //------------------------------------------------------------
      this.lstDisplayData = [];

      let intCount = 1;

      this.excelFileData.forEach(item => {
        let count = 0;
        this.workItemFieldList.forEach(f => {
          if (item[f.parent_field_config_name] == "") {
            count++;
          }
        });

        this.workItemFieldList.forEach(f => {
          if (f.control_type == "DATE") {
            item[f.parent_field_config_name] = this.commonService.dateFormating(new Date((Number(item[f.parent_field_config_name]) - 25569) * 86400000).toString());
          }
        });

        item["srNo"] = intCount;
        item["invoiceFile_name"] = "";

        if (this.selectedDocumentType.is_supportingFile_mandatory == true)
          item["supportingFile_name"] = "";

        let obj = {};
        //no line items
        if (this.workItemFieldChildList.length == 0) {
          this.lstDisplayField.forEach(f => {
            if (f.fieldName == 'Invoice File') {
              obj[f.fieldName] = item["Invoice File Name"];
            }
            else if (f.fieldName == 'Supporting File') {
              obj[f.fieldName] = item["Supporting File Name"];
            }
            else if (f.fieldName == 'Sr No') {
              obj[f.fieldName] = intCount;
            }
            else if (f.fieldName == 'Message') {
              obj[f.fieldName] = "";
            }
            else {
              obj[f.fieldName] = item[f.fieldName];
            }
          });

          this.lstDisplayData.push(obj);
          intCount = intCount + 1;
        }
        else {
          if (count < this.workItemFieldList.length) {

            this.lstDisplayField.forEach(f => {

              if (f.fieldName == 'Invoice File') {
                obj[f.fieldName] = item["Invoice File Name"];
              }
              else if (f.fieldName == 'Supporting File') {
                obj[f.fieldName] = item["Supporting File Name"];
              }
              else if (f.fieldName == 'Sr No') {
                obj[f.fieldName] = intCount;
              }
              else if (f.fieldName == 'Message') {
                obj[f.fieldName] = "";
              }
              else {
                obj[f.fieldName] = item[f.fieldName];
              }
            });
            var obj1 = {};
            var countChildValue = 0;
            this.lstChildDisplayField.forEach(f => {
              if (item[f.fieldName] != null && item[f.fieldName] != "") {
                obj1[f.fieldName] = item[f.fieldName];
              }
              else {
                countChildValue++;
              }
            });
            if (countChildValue < this.lstChildDisplayField.length) {
              obj["lstchild"] = [];
              obj1['Message'] = "";
              obj["lstchild"].push(obj1);
            }
            this.lstDisplayData.push(obj);
            intCount = intCount + 1;
          }
          else {
            item["srNo"] = intCount - 1;
            var obj1 = {};
            var countChildValue = 0;
            this.lstChildDisplayField.forEach(f => {
              if (item[f.fieldName] != null && item[f.fieldName] != "") {
                obj1[f.fieldName] = item[f.fieldName];
              }
              else {
                countChildValue++;
              }
            });
            if (countChildValue < this.lstChildDisplayField.length) {
              obj1['Message'] = "";
              this.lstDisplayData[this.lstDisplayData.length - 1]["lstchild"].push(obj1);
            }
          }
        }
      });

      if (this.fileValidation() == false) {
        this.fileInput.nativeElement.value = '';
        this.selectedExcelFile = this.browseMessage;
        return;
      }


      //-------------------------------
      //File upload on temp location on server
      let reader1 = new FileReader();
      reader1.onload = (e: any) => {
        let base64FileString = reader1.result.toString();
        this.folderName = this.commonService.formatDate(new Date(), "yyyyMMddhhmmss");
        let body = [];
        body.push({
          FileName: this.selectedExcelFile,
          FileData: base64FileString,
          FolderName: this.folderName
        });

        this.dataService.postData("invoice/file", body, this.dataService.apiURL_Core).subscribe(res => {
        });
      };

      reader1.readAsDataURL(excelfile);
      //-------------------------------
    }

    reader.readAsBinaryString(excelfile);

    this.selectedInvoiceFiles = this.browseMessage;
    this.selectedSupportingFiles = this.browseMessage;

    this.fileInput.nativeElement.value = '';
  }


  async onSelectInvoiceFile(invoicefiles: any) {
    debugger;
    if (invoicefiles.target.files) {
      debugger;
      let isValidFile: boolean = true;
      for (let i = 0; i < invoicefiles.target.files.length; i = i + 1) {
        debugger;
        let fileType = invoicefiles.target.files[i].name.split(".")[1];
        if (!this.invoiceFileType.toLowerCase().includes(fileType.toLowerCase())) {
          isValidFile = false;
        }
      }
      debugger;
      if (isValidFile != true) {
        this.commonService.showMessageBox("Invalid invoice file type. <br>" +
          "Valid file type(s) is " + this.invoiceFileType + ".", "Validation Alert");
        return;
      }
      debugger;
      this.selectedInvoiceFiles = "";
      let lstFile = [];

      for (let i = 0; i < invoicefiles.target.files.length; i = i + 1) {
        this.file = invoicefiles.target.files[i];
        let row = this.excelFileData.find(f => f["Invoice File Name"] == invoicefiles.target.files[i].name);
        if (row != undefined) {
          row.invoiceFile_name = "INV_" + invoicefiles.target.files[i].name;
          this.selectedInvoiceFiles = (this.selectedInvoiceFiles == "") ? invoicefiles.target.files[i].name : this.selectedInvoiceFiles + ", " + invoicefiles.target.files[i].name;

          let reader = new FileReader();
          reader.onload = (e: any) => {
            this.fileBase64FileString = reader.result.toString();
            this.fileName = row.invoiceFile_name
            if (i <= this.dataService.Bulk_Upload_File_Count - 1) {
              this.uploadInvoiceAttachment(e);
            }
            //lstFile.push({ FileName: row.invoiceFile_name, FileData: reader.result.toString(), FolderName: this.folderName })
          };
          reader.readAsDataURL(invoicefiles.target.files[i]);
        }
      }

      if (this.selectedInvoiceFiles == "") {
        this.selectedInvoiceFiles = this.browseMessage;
      }

      //-------------------------------
      //File upload on temp location on server

      /*     setTimeout(async () => {
            if (lstFile.length > 0) {
              let cnt = 0;
              for (let i = 0; i < lstFile.length; i = i + 1) {
                cnt++;
                if (cnt == this.dataService.Bulk_Upload_File_Count || i == lstFile.length - 1) {
                  let start = 0;
                  let end = 0;
                  if (i == lstFile.length - 1) {
                    start = (i + 1) - cnt;
                    end = start + cnt;
                  }
                  else {
                    start = (i + 1) - this.dataService.Bulk_Upload_File_Count;
                    end = start + this.dataService.Bulk_Upload_File_Count;
                  }
                  let lst = lstFile.slice(start, end);
                  await this.dataService.postDataPromise("invoice/file", lst).then(res => {
                    lst = [];
                  });
                  cnt = 0;
                }
              }
            }
          }, 1000); */
      //-------------------------------

      // let cnt = 0;
      // let formData: any = new FormData();

      // for (let i = 0; i < invoicefiles.target.files.length; i = i + 1) {
      //   formData.append("INV_" + invoicefiles.target.files[i].name, invoicefiles.target.files[i]);
      //   cnt++;
      //   if (cnt == 10 || i == invoicefiles.target.files.length - 1) {
      //     formData.append("FolderName", this.folderName);
      //     await this.httpClient.post(this.dataService.apiURL_Core + 'invoice/file1', formData).toPromise().then(res => {
      //     })
      //     cnt = 0;
      //     formData = new FormData();
      //   }
      // }


      this.lstDisplayData == JSON.parse(JSON.stringify(this.lstDisplayData));
      this.fileInput1.nativeElement.value = '';
    }
  }

  async onSelectSupportingFile(supportingfile: any) {

    if (supportingfile.target.files) {

      let isValidFile: boolean = true;

      for (let i = 0; i < supportingfile.target.files.length; i = i + 1) {
        let fileType = supportingfile.target.files[i].name.split(".")[1];
        if (!this.supportingFileType.toLowerCase().includes(fileType.toLowerCase())) {
          isValidFile = false;
        }
      }

      if (isValidFile != true) {
        this.commonService.showMessageBox("Invalid supporting file type. <br>" +
          "Valid file type(s) is " + this.supportingFileType + ".", "Validation Alert");
        return;
      }

      this.selectedSupportingFiles = "";
      let lstFile = [];

      for (let i = 0; i < supportingfile.target.files.length; i = i + 1) {
        let row = this.excelFileData.find(f => f["Supporting File Name"] == supportingfile.target.files[i].name);

        if (row != undefined) {
          row.supportingFile_name = "SD_" + supportingfile.target.files[i].name;
          this.selectedSupportingFiles = (this.selectedSupportingFiles == "") ? supportingfile.target.files[i].name : this.selectedSupportingFiles + ", " + supportingfile.target.files[i].name;

          let reader = new FileReader();
          reader.onload = (e: any) => {
            this.fileName = row.supportingFile_name;
            this.fileBase64FileString = reader.result.toString();
            if (i <= this.dataService.Bulk_Upload_File_Count - 1) {
              this.uploadInvoiceAttachment(e);
            }
            //lstFile.push({ FileName: row.supportingFile_name, FileData: reader.result.toString(), FolderName: this.folderName });
          };
          reader.readAsDataURL(supportingfile.target.files[i]);
        }
      }

      if (this.selectedSupportingFiles == "") {
        this.selectedSupportingFiles = this.browseMessage;
      }

      //-------------------------------
      //File upload on temp location on server
      /*   setTimeout(async () => {
          if (lstFile.length > 0) {
            let cnt = 0;
            for (let i = 0; i < lstFile.length; i = i + 1) {
              cnt++;
              if (cnt == this.dataService.Bulk_Upload_File_Count || i == lstFile.length - 1) {
                let start = 0;
                let end = 0;
                if (i == lstFile.length - 1) {
                  start = (i + 1) - cnt;
                  end = start + cnt;
                }
                else {
                  start = (i + 1) - this.dataService.Bulk_Upload_File_Count;
                  end = start + this.dataService.Bulk_Upload_File_Count;
                }
                let lst = lstFile.slice(start, end);
                await this.dataService.postDataPromise("invoice/file", lst).then(res => {
                  lst = [];
                });
                cnt = 0;
              }
            }
          }
        }, 1000);
   */
      //-------------------------------

      // let cnt = 0;
      // let formData: any = new FormData();

      // for (let i = 0; i < supportingfile.target.files.length; i = i + 1) {
      //   formData.append("SD_" + supportingfile.target.files[i].name, supportingfile.target.files[i]);
      //   cnt++;
      //   if (cnt == 10 || i == supportingfile.target.files.length - 1) {
      //     formData.append("FolderName", this.folderName);
      //     await this.httpClient.post(this.dataService.apiURL_Core + 'invoice/file1', formData).toPromise().then(res => {
      //     })
      //     cnt = 0;
      //     formData = new FormData();
      //   }
      // }

      this.lstDisplayData == JSON.parse(JSON.stringify(this.lstDisplayData));
      this.fileInput2.nativeElement.value = '';
    }
  }


  async uploadInvoiceAttachment(event: any) {
    let body = [];
    body.push({
      FileName: this.fileName,
      FileData: this.fileBase64FileString,
      FolderName: this.folderName
    });
    await this.dataService.postDataPromise("invoice/file", body).then(res => {
      if (res) {
        if (res.success) {

        }
        else {
          this.commonService.showMessageBox("Failed to upload", 'Warning');
        }
      }
    });
  }

  fileValidation(): Boolean {

    let validate: boolean;
    let ep = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    let intRowCount = 0;

    let lenMessage = "";
    let mandatoryFields = "";
    let numericFields = "";
    let emailFields = "";
    let emailFields_domain = "";
    let childlenMessage = "";
    let childmandatoryFields = "";
    let childnumericFields = "";
    let childdropdownFields = "";
    let childemailFields = "";
    let childemailFields_domain = "";
    let childvalidationMessage = "";
    let validationMessage = "";
    let isValidate: boolean = true;
    let areAllcolumnempty: boolean = true;
    let areAllchildcolumnempty: boolean = true;
    let childitemerror = false;


    this.lstDisplayData.forEach(data => {

      mandatoryFields = "";
      numericFields = "";
      emailFields = "";
      emailFields_domain = "";
      validationMessage = "";
      areAllcolumnempty = true;
      childitemerror = false;

      this.workItemFieldList.forEach(field => {
        let fieldValue = data[field.parent_field_config_name];

        if (fieldValue == null || fieldValue == undefined) fieldValue = "";

        if (field.is_mandatory_for_doc_creation_vendor == 1) {
          if (fieldValue == "") {
            if (mandatoryFields.search(field.parent_field_config_name) == -1)
              mandatoryFields = (mandatoryFields == "") ? field.parent_field_config_name : mandatoryFields + ", " + field.parent_field_config_name;
          }
        }

        if (field.is_readonly == 0 && field.control_type == 'TEXTBOX') {
          if (fieldValue.toString().length > field.max_length) {
            lenMessage = (lenMessage == "") ? field.parent_field_config_name : lenMessage + ", " + field.parent_field_config_name;
          }

          if (field.validation_type == 'NUMERIC') {
            if (isNaN(+fieldValue)) {
              if (numericFields.search(field.parent_field_config_name) == -1)
                numericFields = (numericFields == "") ? field.parent_field_config_name : numericFields + ", " + field.parent_field_config_name;
            }
          }

          if (field.validation_type == 'EMAIL') {
            if (fieldValue != "") {
              if (!ep.test(fieldValue)) {
                if (emailFields.search(field.parent_field_config_name) == -1)
                  emailFields = (emailFields == "") ? field.parent_field_config_name : emailFields + ", " + field.parent_field_config_name;
              }
              else {
                if (field.domainexceptionvalue != '') {
                  if (field.domainexceptionvalue.search(fieldValue.split('@').pop()) == -1) {
                    if (emailFields_domain.search(field.parent_field_config_name) == -1)
                      emailFields_domain = (emailFields_domain == "") ? field.parent_field_config_name : emailFields_domain + ", " + field.parent_field_config_name;
                  }
                }
              }
            }
          }
        }

        if (field.actions != null && field.actions != '') {
          var actions = JSON.parse(field.actions);
          actions.forEach(action => {
            if (action.action_trigger == 'SUBMIT') {
              let isNotBlank = true;

              let formula: string;
              let targetfieldvalue = "";
              let fname = "";

              if (action.action_type == 'VALIDATION') {
                if (action.validation_type == 'COMPARE') {
                  if (action.execute_mode == 'NORMAL') {
                    isNotBlank = (action.condition == 'not_blank') ? fieldValue != "" && fieldValue != undefined : true;

                    //Comparing only when the target field is present in workItemFieldList list
                    if (this.workItemFieldList.findIndex(a => a.db_column_name == action.target_db_column_name) != -1) {
                      fname = this.workItemFieldList.find(a => a.db_column_name == action.target_db_column_name).parent_field_config_name
                      targetfieldvalue = data[fname];

                      if (isNotBlank && fieldValue != targetfieldvalue) {
                        if (validationMessage != "") validationMessage = validationMessage + " ";
                        validationMessage = field.parent_field_config_name + " does not matched with " + this.workItemFieldList.find(x => x.db_column_name == action.target_db_column_name).parent_field_config_name;
                      }
                    }

                  } else if (action.execute_mode == 'FORMULA') {
                    formula = action.formula;
                    let isAllFieldExist: boolean = true;
                    //We need to check weather all target fields are available in workItemFieldList
                    action.formula_fields.split(",").forEach(f => {
                      if (this.workItemFieldList.findIndex(a => a.db_column_name == action.target_db_column_name) == -1) {
                        isAllFieldExist = false
                      }
                    });

                    if (isAllFieldExist) {
                      action.formula_fields.split(",").forEach(f => {
                        let fname = this.workItemFieldList.find(a => a.db_column_name == f).parent_field_config_name
                        targetfieldvalue = data[fname];
                        formula = formula.replace(f, (targetfieldvalue != "" && targetfieldvalue != undefined && targetfieldvalue != null) ? targetfieldvalue : '0');
                      });

                      let result = eval(formula);

                      if (!result) {
                        if (validationMessage != "") validationMessage = validationMessage + " ";
                        if (action.error_message != undefined)
                          validationMessage = validationMessage + action.error_message
                        else
                          validationMessage = validationMessage + "Invalid value of " + field.parent_field_config_name + ".";
                      }
                    }
                  }
                }
                else if (action.validation_type == 'MANDATORY') {
                  if (fieldValue == "" || fieldValue == undefined) {
                    if (action.execute_mode == 'NORMAL') {
                    } else if (action.execute_mode == 'FORMULA') {
                      let isAllFieldExist: boolean = true;
                      action.formula_fields.split(",").forEach(f => {
                        if (this.workItemFieldList.findIndex(a => a.db_column_name == f) == -1) {
                          isAllFieldExist = false
                        }
                      });

                      if (isAllFieldExist) {
                        formula = action.formula;
                        action.formula_fields.split(",").forEach(f => {
                          let fname = this.workItemFieldList.find(a => a.db_column_name == f).parent_field_config_name
                          targetfieldvalue = data[fname];
                          formula = formula.replace(f, (targetfieldvalue != "" && targetfieldvalue != undefined && targetfieldvalue != null) ? targetfieldvalue : '0');
                        });

                        let result = eval(formula);

                        if (result) {
                          if (validationMessage != "") validationMessage = validationMessage + " ";
                          if (action.error_message != undefined)
                            validationMessage = validationMessage + action.error_message
                          else
                            validationMessage = validationMessage + field.parent_field_config_name + " is mandatory.";
                        }
                      }
                    }
                  }
                }
              }

            }
          });

        }

        if (field.fix_length > 0 && (field.is_mandatory_for_doc_creation_vendor == 1 || fieldValue != '')) {
          if (fieldValue.toString().length != field.fix_length) {
            if (validationMessage != "") validationMessage = validationMessage + " ";
            validationMessage = "Length of " + field.parent_field_config_name + " must be " + field.fix_length + ".";
          }
        }

        if (field.max_length > 0) {
          if (fieldValue.toString().length > field.max_length) {
            if (validationMessage != "") validationMessage = validationMessage + " ";
            validationMessage = "Length of " + field.parent_field_config_name + " is up to " + field.max_length + ".";
          }
        }

        if (this.invoiceNumberDBColumnName == field.db_column_name) {
          for (let iRow: number = 0; iRow < this.lstDisplayData.length; iRow = iRow + 1) {
            if (iRow > intRowCount) {
              if (fieldValue == this.lstDisplayData[iRow][field.parent_field_config_name]) {
                validationMessage = validationMessage + "Duplicate Invoice Number.";
                break;
              }
            }
          }
        }

      });

      if (mandatoryFields != "") {
        if (validationMessage != "") validationMessage = validationMessage + " ";

        validationMessage = mandatoryFields + " is mandatory.";
      }

      if (numericFields != "") {
        if (validationMessage != "") validationMessage = validationMessage + " ";

        validationMessage = validationMessage + numericFields + " should be numeric."
      }

      if (emailFields != "") {
        if (validationMessage != "") validationMessage = validationMessage + " ";

        validationMessage = validationMessage + emailFields + " is invalid."
      }

      if (emailFields_domain != "") {
        if (validationMessage != "") validationMessage = validationMessage + " ";

        validationMessage = validationMessage + emailFields_domain + " has invalid domain."
      }

      if (this.workItemFieldChildList != null) {
        if (this.workItemFieldChildList.length > 0) {
          if (data.lstchild != null) {
            data.lstchild.forEach(data1 => {
              //This is for child level records
              childlenMessage = "";
              childmandatoryFields = "";
              childnumericFields = "";
              childemailFields = "";
              childemailFields_domain = "";
              childvalidationMessage = "";
              childdropdownFields = "";

              this.workItemFieldChildList.forEach(field => {
                let fieldValue = data1[field.parent_field_config_name];

                if (fieldValue == null || fieldValue == undefined) fieldValue = "";

                if (field.is_mandatory == 1) {
                  if (fieldValue == "") {
                    if (childmandatoryFields.search(field.parent_field_config_name) == -1)
                      childmandatoryFields = (childmandatoryFields == "") ? field.parent_field_config_name : childmandatoryFields + ", " + field.parent_field_config_name;
                  }
                }

                if (field.is_readonly == 0 && field.control_type == 'TEXTBOX') {
                  if (fieldValue.toString().length > field.max_length) {
                    childlenMessage = (childlenMessage == "") ? field.parent_field_config_name : childlenMessage + ", " + field.parent_field_config_name;
                  }

                  if (field.validation_type == 'NUMERIC') {
                    if (isNaN(+fieldValue)) {
                      if (childnumericFields.search(field.parent_field_config_name) == -1)
                        childnumericFields = (childnumericFields == "") ? field.parent_field_config_name : childnumericFields + ", " + field.parent_field_config_name;
                    }
                  }

                  if (field.validation_type == 'EMAIL') {
                    if (fieldValue != "") {
                      if (!ep.test(fieldValue)) {
                        if (childemailFields.search(field.parent_field_config_name) == -1)
                          childemailFields = (childemailFields == "") ? field.parent_field_config_name : childemailFields + ", " + field.parent_field_config_name;
                      }
                      else {
                        if (field.domainexceptionvalue != '') {
                          if (field.domainexceptionvalue.search(fieldValue.split('@').pop()) == -1) {
                            if (childemailFields_domain.search(field.parent_field_config_name) == -1)
                              childemailFields_domain = (childemailFields_domain == "") ? field.parent_field_config_name : childemailFields_domain + ", " + field.parent_field_config_name;
                          }
                        }
                      }
                    }
                  }
                }

                if (field.control_type == 'DROPDOWN') {
                  if (fieldValue != "") {
                    const fieldText = field.options.find((d) => d.name.toUpperCase() == fieldValue.toUpperCase()) ?.name;
                    if (fieldText == undefined) {
                      if (childdropdownFields.search(field.parent_field_config_name) == -1)
                        childdropdownFields = (childdropdownFields == "") ? field.parent_field_config_name : childdropdownFields + ", " + field.parent_field_config_name;
                    }
                  }
                }
              });

              if (childmandatoryFields != "") {
                if (childvalidationMessage != "")
                  childvalidationMessage = childvalidationMessage + " ";

                childvalidationMessage = childmandatoryFields + " is mandatory.";
              }

              if (childdropdownFields != "") {
                if (childvalidationMessage != "")
                  childvalidationMessage = childvalidationMessage + " ";

                childvalidationMessage = childvalidationMessage + "Invalid " + childdropdownFields + "."
              }

              if (childnumericFields != "") {
                if (childvalidationMessage != "")
                  childvalidationMessage = childvalidationMessage + " ";

                childvalidationMessage = childvalidationMessage + childnumericFields + " should be numeric."
              }

              if (childemailFields != "") {
                if (childvalidationMessage != "")
                  childvalidationMessage = childvalidationMessage + " "

                childvalidationMessage = childvalidationMessage + childemailFields + " is invalid."
              }

              if (childemailFields_domain != "") {
                if (childvalidationMessage != "")
                  childvalidationMessage = childvalidationMessage + " "

                childvalidationMessage = childvalidationMessage + childemailFields_domain + " has invalid domain."
              }

              if (childvalidationMessage != "") {
                childitemerror = true;
                data1['Message'] = childvalidationMessage;
              }

            });
          }
        }
      }

      if (validationMessage != "") {
        isValidate = false;
        data['Message'] = validationMessage;
      }

      if (childitemerror) {
        isValidate = false;
        data['Message'] = validationMessage + " Line item invalid data";
      }

      // if ((areAllcolumnempty == Boolean(false)) && (areAllchildcolumnempty == Boolean(false))) {
      //   isValidate = false;
      //   data['Message'] = validationMessage + childvalidationMessage;
      // }

      intRowCount = intRowCount + 1;
    });

    if (isValidate != true) {
      this.commonService.showMessageBox("Data in excel file are invalid. <br> Please look at the Message column on grid for more detail.", "Validation Alert");
      return false;
    }

    //-------------------------------------------------------
    return true;
  }

  async uploadBulkInvoice() {

    //Invoice and Supporing File Validation--Start
    let isValid_invoice: boolean = true;
    let isValid_supporting: boolean = true;

    let invoiceNo = "";
    let invoiceNoSD = "";
    let invalidFieldLengthMsg = '';

    let lstSrNo = [];

    this.excelFileData.forEach(data => {
      let IsCheckLineItem = true;

      this.workItemFieldList.forEach(field => {
        let fieldValue = data[field.parent_field_config_name];

        if (fieldValue == null || fieldValue == undefined)
          fieldValue = "";

        // START: field length validation
        if (field.control_type == 'TEXTBOX') {
          let fix_length = 0;
          if (field.min_length == field.max_length) {
            fix_length = field.min_length;
          }

          if (fix_length > 0 && fieldValue != '') {

            if (fieldValue.toString().length != fix_length) {
              if (invalidFieldLengthMsg == "")
                invalidFieldLengthMsg = "Length of " + field.parent_field_config_name + " must be " + fix_length + ".";
              else
                invalidFieldLengthMsg = invalidFieldLengthMsg + "<BR>" + "Length of " + field.parent_field_config_name + " must be " + fix_length + ".";
            }
          }

          if (fix_length == 0 && field.min_length > 0 && fieldValue != '') {
            if (fieldValue.toString().length < field.min_length) {
              if (invalidFieldLengthMsg == "")
                invalidFieldLengthMsg = "Length of " + field.parent_field_config_name + " is min " + field.min_length + ".";
              else
                invalidFieldLengthMsg = invalidFieldLengthMsg + "<BR>" + "Length of " + field.parent_field_config_name + " is min " + field.min_length + ".";
            }
          }

          if (fix_length == 0 && field.max_length > 0) {
            if (fieldValue.toString().length > field.max_length) {
              if (invalidFieldLengthMsg == "")
                invalidFieldLengthMsg = "Length of " + field.parent_field_config_name + " is up to " + field.max_length + ".";
              else
                invalidFieldLengthMsg = invalidFieldLengthMsg + "<BR>" + "Length of " + field.parent_field_config_name + " is up to " + field.max_length + ".";
            }
          }
        }
        // END: field length validation

        //if (field.is_mandatory == 1) {
        if (fieldValue == "") {
          IsCheckLineItem = false;
        }
        else {
          IsCheckLineItem = true;
        }
        //}
      });

      if (IsCheckLineItem) {
        if (data["invoiceFile_name"] == "") {
          isValid_invoice = false;
          if (lstSrNo.findIndex(a => a == data['srNo']) == -1) {

            invoiceNo = (invoiceNo == "") ? data['srNo'] : invoiceNo + ", " + data['srNo'];
          }
          if (this.selectedDocumentType.is_supportingFile_mandatory == true && data["supportingFile_name"] == "") {
            isValid_supporting = false;
            if (lstSrNo.findIndex(a => a == data['srNo']) == -1) {
              invoiceNoSD = (invoiceNoSD == "") && lstSrNo.findIndex(a => a == data['srNo']) != -1 ? data['srNo'] : invoiceNoSD + ", " + data['srNo'];
              lstSrNo.push(data['srNo']);
            }
          }
        }
      }
    });

    if (invalidFieldLengthMsg != '') {
      this.commonService.showMessageBox(invalidFieldLengthMsg, 'Alert');
      return;
    }

    if (isValid_invoice != true) {
      this.commonService.showMessageBox("Please select the supported file(s) for the below Sr.No.<br>" + invoiceNo, "Alert");
      return;
    }
    if (isValid_supporting != true) {
      this.commonService.showMessageBox("Please select supporting file(s) for the below record number(s).<br>" + invoiceNoSD, "Alert");
      return;
    }

    //------------------------------------------------
    //Submit code -- Start

    let companyType = await this.getCompanyType();

    let params = {
      DocumentTypeID: this.selectedDocumentType.docTypeId,
      // CreatedBy: Number(this.commonService.getUserInfoFromLocalStorage('userId')),
      // SubgroupID: (this.commonService.getUserInfoFromLocalStorage('subgroupId') == "null") ? 0 : Number(this.commonService.getUserInfoFromLocalStorage('subgroupId')),
      // RoleID: Number(this.commonService.getUserInfoFromLocalStorage('roleId')),
      // ProjectID: Number(this.commonService.getUserInfoFromLocalStorage('projectId')),
      CreatedBy: Number(this.memorystore.getItem('userId')),
      SubgroupID: (this.memorystore.getItem('subgroupId') == "null") ? 0 : Number(this.memorystore.getItem('subgroupId')),
      RoleID: Number(this.memorystore.getItem('roleId')),
      ProjectID: Number(this.memorystore.getItem('projectId')),
      Comment: '',
      TotalRecord: this.lstDisplayData.length,
      FileName: this.selectedExcelFile,
      IsBackgroudProcess: true,
      VendorType: companyType,
      VendorCode: '',
      VendorId: 0,
      ModuleName: "PI",
      FolderName: this.folderName
    }


    this.dataService.postData("workitem/uploadbulkinvoice", params, this.dataService.apiURL_Core).subscribe(res => {
      if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
        if (res.success == true) {
          const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            disableClose: true,
            data: {
              title: "Message",
              message: 'Submitted ' + this.lstDisplayData.length + ' invoice(s). Processing in progress.',
              messageBoxType: 'ok'
            }
          });
          dialogRef.afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {
              this.getFileHistory();
              this.selectedTab = 1;
              this.reset(false);
            } else {
            }
          });
        }
        else {
          this.commonService.showMessageBox(res.errorMessage, "Alert");
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
    //Submit code -- End
    //------------------------------------------------

  }

  reset(isGridReset) {
    this.selectedExcelFile = this.browseMessage;
    this.selectedInvoiceFiles = this.browseMessage;
    this.selectedSupportingFiles = this.browseMessage;

    this.invoiceFileType = "";
    this.supportingFileType = "";

    this.invoiceFileSize = "";
    this.supportingFileSize = "";

    this.isValidated = false;
    this.excelFileData = [];

    //this.vendorNameDBColumnName = '';

    this.lstDisplayField = [];
    this.lstDisplayData = [];


    if (isGridReset) {
      this.lstHistoryData = [];
      this.selectedDocumentType = undefined;
      this.workItemFieldList = [];
      this.workItemFieldChildList = [];
      this.invoiceNumberDBColumnName = '';
    }
  }

  getStatusClass(STATUS) {
    if (STATUS == '' || STATUS == 'Success')
      return "completed-status-btn";
    else if (STATUS == 'In Progess')
      return "in-progress-status-btn";
    else if (STATUS == 'Fail')
      return "error-status-btn";
    else
      return "completed-status-btn";
  }

  getStyle(col, value) {
    let style = {};

    if (col == 'Invoice File') {
      let a = this.excelFileData.find(f => f["Invoice File Name"] == value);
      if (a != undefined) {
        if (a.invoiceFile_name == "INV_" + value)
          style = { color: 'green' };
        else
          style = { color: 'red' };
      }
    }
    else if (col == 'Supporting File') {
      let a = this.excelFileData.find(f => f["Supporting File Name"] == value);
      if (a != undefined) {
        if (a.supportingFile_name == "SD_" + value)
          style = { color: 'green' };
        else
          style = { color: 'red' };
      }
    }
    else if (col == 'Status') {
      if (value == 'Success') {
        style = { color: 'green' };
      }
      else if (value == 'Fail') {
        style = { color: 'red' };
      }
      else {
        style = { color: 'blue' };
      }
    }
    return style;
  }

  onRefreshClick() {
    this.getFileHistory();
  }

  cellClick(edata) {
    if (edata.rowData.Status != 'In Progress'
      && (edata.columnName == 'No Of Valid' || edata.columnName == 'No Of Invalid' || edata.columnName == 'No Of Duplicate' || edata.columnName == 'Total Records')
      && Number(edata.rowData[edata.columnName]) > 0) {
      let params = new HttpParams();
      params = params.append("fileId", edata.rowData.File_Id);
      // params = params.append("projectId", this.commonService.getUserInfoFromLocalStorage('projectId'));
      // params = params.append("roleId", this.commonService.getUserInfoFromLocalStorage('roleId'));
      params = params.append("projectId", this.memorystore.getItem('projectId'));
      params = params.append("roleId", this.memorystore.getItem('roleId'));
      params = params.append("documentTypeId", this.selectedDocumentType.docTypeId);
      params = params.append("flag", (edata.columnName == 'No Of Valid') ? '1' : (edata.columnName == 'No Of Invalid') ? '2' : (edata.columnName == 'No Of Duplicate') ? 3 : '0');
      params = params.append("moduleName", 'AP');

      this.dataService.getData("invoice/getuploadfiledata", params, this.dataService.apiURL_Core).subscribe(res => {
        if (res.success == true && res.data != undefined) {
          let seq = 0;
          let objData = {};
          this.lstHistoyFileData = [];
          res.data.forEach(row => {
            objData = {};
            seq = seq + 1
            objData['Sr No'] = seq;
            Object.keys(row).forEach(col => {
              objData[col] = row[col];

              let field = this.workItemFieldList.find(f => f.PARENT_FIELD_CONFIG_NAME == col);
              if (field != undefined) {
                if (field.CONTROL_TYPE == "DATE")
                  objData[col] = this.commonService.formatDate(row[col], this.commonService.DateFormat);
              }
            });
            this.lstHistoyFileData.push(objData);
          });

          this.showModal(this.modelTemplate, "lg");
        }
        else {
          this.commonService.showMessageBox(res.errorMessage, "Message", "error")
        }
      }, err => {
        this.commonService.showMessageBox(err.toString(), "Message", "error")
      });
    }
  }

  showModal(modelTemplate, modalSize: string = 'lg') {
    this.modalReference = this.modalService.open(modelTemplate, {
      size: modalSize, centered: true, backdrop: 'static',
      keyboard: false
    });
  }

  downloadData() {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.lstHistoyFileData);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'LoadDataSheet');
    XLSX.writeFile(wb, 'FileData' + '_' + new Date().getTime() + '.xlsx');
  }

  onCloseButtionClick() {
    this.modalReference.close();
  }

  async getCompanyType(): Promise<string> {
    let companyType = "";

    let params = new HttpParams();
    // params = params.append("projectId", this.commonService.getUserInfoFromLocalStorage('projectId'));
    params = params.append("projectId", this.memorystore.getItem('projectId'));
    return await this.dataService.getDataPromise("dashboard/companytype", params).then(res => {
      if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
        if (res.success == true) {
          if (res.data.length > 0) {
            let cid = 0;
            let field = this.workItemFieldList_All.find(x => x.parent_field_config_name == 'Company Type');
            if (field != undefined) {
              cid = field.dropdown_value;

              let company = res.data.find(d => d.ID == cid)
              if (company != undefined) {
                companyType = company.COMPANY_TYPE;
              }
            }
          }
        }
        return companyType;
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
        return '';

      }

    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
        }
        return "";
      }).catch(err => {
        return "";
      });
    //return companyType;
  }

}
